export default "__VITE_ASSET__D$oh2Kir__"